import { Component, Vue, Watch } from 'vue-property-decorator';

const DB_NAME = "persistence";
const STORES = ["components"]
const VERSION_ID = 1

@Component
export default class PersistenceComponentMixin extends Vue {
    async beforeMount() {

        const data = JSON.parse(window.sessionStorage.getItem(this.$options.name as string) as any);

        if (data) {
            Object.keys(data).forEach(propertie => {
                this[propertie] = data[propertie];
            })
        }
    }

    @Watch("$data", { deep: true })
    dataChanged(){
      this.persistComponentData();
    }

    persistComponentData() {
        window.sessionStorage.setItem(this.$options.name as string, JSON.stringify(this.$data) as any)
    }
}